export type AppWebViewUserSyncStatus = 'idle' | 'loading' | 'ready'

export const isRunningInAppWebView = () =>
  typeof window !== 'undefined' &&
  !!(window as Window & { ReactNativeWebView?: unknown }).ReactNativeWebView

export const shouldWaitForAppWebViewUserSync = (
  isAppWebView: boolean,
  status: AppWebViewUserSyncStatus
) => isAppWebView && status !== 'ready'

export const shouldRefreshUserFromInfo = ({
  isAppWebView,
  hasUser,
  hasStoredUser,
  hasValidToken,
  refreshAttempted,
}: {
  isAppWebView: boolean
  hasUser: boolean
  hasStoredUser: boolean
  hasValidToken: boolean
  refreshAttempted: boolean
}) =>
  !refreshAttempted &&
  (isAppWebView ? hasValidToken : !hasUser && (hasStoredUser || hasValidToken))
